const snakeCase = text => {
  return (
    (text &&
      text
        .replace(/\W+/g, ' ')
        .split(/ |\B(?=[A-Z])/)
        .map(word => word.toLowerCase())
        .join('_')) ||
    ''
  );
};

function dashesOnlyToCamelCase(text) {
  if (!text) return '';
  const dashesTitleCase = text
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.substr(1))
    .join('');
  return dashesTitleCase.charAt(0).toLowerCase() + dashesTitleCase.substr(1);
}

export { snakeCase, dashesOnlyToCamelCase };
export default snakeCase;
